module.exports = require("regenerator-runtime");



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-scripts/~/babel-preset-react-app/~/babel-runtime/regenerator/index.js
 ** module id = 125
 ** module chunks = 0
 **/